const firebaseConfig = {
    apiKey: "AIzaSyAeH8b7y6hqYjDyDD9vJWfKAnT6CX_MfMc",
    authDomain: "michigan-state-28019.firebaseapp.com",
    projectId: "michigan-state-28019",
    storageBucket: "michigan-state-28019.appspot.com",
    messagingSenderId: "482408067372",
    appId: "1:482408067372:web:3a5b3323ed74cb74d67c89"
};

export default firebaseConfig;
